import { tagColors } from "@/components/tag/tag-colors";
export const PurchasePlanEnum = {
    // 采购计划状态
    status: {
        DRAFT: 'draft',
        WAIT_REVIEW: 'waitReview',
        REJECTED: 'rejected',
        WAIT_HANDLE: 'waitHandle',
        PROCESSED: 'processed',
        ABOLISHED: 'abolished'
    },
    keyWord:[
        {id: 'purchasePlanCode', text: '采购计划'},
        {id: 'shipPlanCode', text: '发货计划'},
        {id: 'createUser', text: '创建人'},
        {id: 'sku', text: 'SKU'},
        {id: 'productName', text: '产品名称'},
    ],
    // 下拉列表状态
    statusOption: [
        {id: 'processing', text: '进行中', ...tagColors.orange},
        {id: 'draft', text: '草稿', ...tagColors.blue},
        {id: 'waitReview', text: '待审核', ...tagColors.orange},
        {id: 'rejected', text: '已驳回', ...tagColors.red},
        {id: 'waitHandle', text: '待处理', ...tagColors.orange},
        {id: 'processed', text: '已处理', ...tagColors.green},
        {id: 'abolished', text: '已作废', ...tagColors.lightGray},
    ],
    // 批量操作
    batchOperation: [
        {id: 'edit', text: '编辑'},
        {id: 'pushReview', text: '提审' },
        {id: 'pass', text: '审核通过' },
        {id: 'reject', text: '审核驳回'},
        {id: 'invalid', text: '作废'},
        {id: 'del', text: '删除'}
    ],
    batchOperationClose: [
        {id: 'edit', text: '编辑'},
        {id: 'invalid', text: '作废'}
    ],
    type: {
        ADD: 0,
        UPDATE: 1,
        COPY: 2,
        VIEW: 3,
        USE: 4,
    },
    // 日志列
    logColumns: [
        {id: 'createDate', header: '操作时间', field: 'createTime', minWidth: '120px'},
        {id: 'opUser', header: '操作用户', field: 'createUserName', minWidth: '100px'},
        {
            id: 'op', header: '操作分类', field: 'option:op', options: [
                {id: 'save', text: '新增为草稿'},
                {id: 'update', text: '更新'},
                {id: 'saveArraignment', text: '新增'},
                {id: 'updateArraignment', text: '修改并提审'},
                {id: 'arraignment', text: '提审'},
                {id: 'reviewYes', text: '审核通过'},
                {id: 'reviewNo', text: '审核不通过'},
                {id: 'under', text: '下单'},
                {id: 'fastInbound', text: '快捷入库'},
                {id: 'endDeliveryNote', text: '结束交货'},
                {id: 'abolished', text: '作废'},
                {id: 'saveDeliveryNote', text: '新增交货单'},
                {id: 'saveOrderChange', text: '新增变更单'},
                {id: 'purchaseInbound', text: '采购入库'},
            ],
            minWidth: '120px'
        },
        {id: 'content', header: '操作内容', field: 'content', overflowLine: 2, minWidth: '300px'}
    ]
};
